import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header/Header';
import ScrollToTopButton from '../components/ScrollToTopButton/ScrollToTopButton';

const MainLayout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.search]);

  useEffect(() => {
    const root = document.querySelector('main.main-content');
    if (!root) return undefined;

    const selectors = [
      /* Common top blocks */
      '.page-header',
      '.about-hero',
      '.hero-banner',
      '.promo-banner',

      /* Sections & Main containers */
      'section',
      '.best-seller-page',
      '.products-page',
      '.story-hero',

      /* Common “card/grid” items */
      '.product-grid > *',
      '.category-grid > *',
      '.featured-banners > *',
      '.beauty-tips-card',
      '.gallery-item',
      '.partners-grid > *',
    ];

    const candidates = Array.from(root.querySelectorAll(selectors.join(', ')))
      .filter((el) => el instanceof HTMLElement)
      .filter((el) => el.offsetHeight > 10);

    // Hiển thị tất cả ngay lập tức — không chờ scroll
    candidates.forEach((el) => {
      el.classList.add('is-visible');
    });
  }, [location.pathname, location.search]);

  return (
    <div className="app-container">
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <ScrollToTopButton />
    </div>
  );
};

export default MainLayout;
